<div class="card">
  <div class="card-block pb-5 pt-5">
    <div class="row justify-content-md-center">
      <div class="col-lg-5 col-md-12">
        <div class="card">
          <img class="card-img-top" src="assets/images/computers.png" alt="Computers" />
          <div class="card-block mt-4">
            <h2 class="card-title mb-4">Need help with our app?</h2>
            <div class="card-text">
              <div class="lead">
                Storyboard from EURORADIO is an Open Source project designed
                to give broadcasters the ability to create slideshows that augment audio clips.
              </div>
              <b>Keyboard shortcuts during edit:</b><br>
              <ul>
                <li>Alt + Space : Play / Pause clip</li>
                <li>Alt + Backspace : Jump to beginning of the clip</li>
                <li>Alt + + : Zoom in</li>
                <li>Alt + - : Zoom in</li>
                <li>Alt + RightArrow : Seek forward (1 second)</li>
                <li>Alt + LeftArrow : Seek backward (1 second)</li>
                <li>Alt + Ctrl + RightArrow : Fast seek forward (10 seconds)</li>
                <li>Alt + Ctrl + LeftArrow : Fast seek backward (10 seconds)</li>
                <li>Alt + Shift + RightArrow : Precision seek forward (250 ms)</li>
                <li>Alt + Shift + LeftArrow : Precision seek backward (250 ms)</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/lnN9os73VA4" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/help/help.component.html